import { render, staticRenderFns } from "./rxnt.vue?vue&type=template&id=8bfce8e0&scoped=true&v-once=true"
import script from "./rxnt.vue?vue&type=script&lang=js"
export * from "./rxnt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfce8e0",
  null
  
)

export default component.exports